var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.name === 'NotFound')?_c('div',[_c('h3',{staticClass:"h4"},[_vm._v("Convite não encontrado")]),_c('p',{staticClass:"mb-0"},[_vm._v("O convite que você está tentando acessar não existe ou foi respondido.")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }